










































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Product } from '@/models/product';
import { OrderComplainModel } from '@/models/order-complain';
import u from '@/utility/utility';

@Component
export default class ListProduct extends Vue {
    private eventEmit = {
        eventChangeDataComplain: 'eventChangeDataComplain'
    };

    @Prop({default: []})
    private products!: Product[];
    @Prop({default: null})
    private complain!: OrderComplainModel;

    get productsQuantity() {
        return this.products.reduce((total: number, prod: Product) => {
            return total + (prod.quantity || 0);
        }, 0);
    }

    get productsAmount() {
        return {
            amountCNY: this.products.reduce((amount: number, prod: Product) => {
                return amount + (prod.quantity * (prod.pricePromotion || prod.priceOrigin));
            }, 0),
            amountVND: this.products.reduce((amount: number, prod: Product) => {
                return amount + (prod.quantity * (prod.pricePromotionVND || prod.priceOriginVND));
            }, 0)
        }
    }

    protected proxyImage(src: string): string {
        return u.proxyImage(src);
    }

    onSelectedProduct(index: number) {
        this.products[index].isChoose = !this.products[index].isChoose;
        this.$emit(this.eventEmit.eventChangeDataComplain, {
            products: this.products.filter(x => x.isChoose === true) || []
        });
    }
}
